module.exports = __webpack_public_path__ + "img/wrapbg6.a6370a0e.png";